import { render } from "./BlackHoleButton.vue?vue&type=template&id=18e5e0c6&scoped=true&ts=true"
import script from "./BlackHoleButton.vue?vue&type=script&lang=ts"
export * from "./BlackHoleButton.vue?vue&type=script&lang=ts"

import "./BlackHoleButton.vue?vue&type=style&index=0&id=18e5e0c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e5e0c6"]])

export default __exports__